import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { closeRoutingProfileBeforeRemoveEpic } from './_epics/closeRoutingProfileBeforeRemove.epic';
import { reloadRoutingProfileListEpic } from './_epics/reloadRoutingProfileList.epic';
import { toggleViewRoutingProfileSidebarEpic } from './_epics/toggleViewRoutingProfileSidebar.epic';

export const controllerRoutingProfileEpic = safeCombineEpics(
  closeRoutingProfileBeforeRemoveEpic,
  reloadRoutingProfileListEpic,
  toggleViewRoutingProfileSidebarEpic,
);
